module.exports = __webpack_public_path__ + "static/projekt-etykiety-wodka-wschodnia-3cdaffa4793ad642d567efcc87cd3126.jpg";